export function makeCamelCase(value: string): string {
  return value
    .toLocaleLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
}

export function unCamelCase(value: string) {
  return value.replaceAll(/[A-Z]/g, (l) => ' ' + l.toLowerCase());
}

export function titleCase(value: string) {
  return value.replaceAll(/\b\w/g, (l) => l.toUpperCase());
}
